module.exports = __webpack_public_path__ + "static/media/huawei-store.7ab42023.svg";